import { t } from 'i18next';
// eslint-disable-next-line no-restricted-imports
import Quill from 'quill';
import {
  AI_EMAIL_LINK_CLASS,
  AI_EMAIL_LINK_FORMAT,
  AI_EMAIL_PLACEHOLDER_CLASS,
  AI_EMAIL_PLACEHOLDER_FORMAT,
  AI_EMAIL_SENDER_CLASS,
  AI_EMAIL_SENDER_FORMAT,
  AI_EMAIL_SOFT_BREAK_CLASS,
  AI_EMAIL_SOFT_BREAK_FORMAT,
} from './ai-email-editor.constants';

const Embed = Quill.import('blots/embed');
const Inline = Quill.import('blots/inline');
const Parchment = Quill.import('parchment');

const PLACEHOLDER_ATTRIBUTE = 'data-placeholder';

const PLACEHOLDER_LABEL_KEYS: Record<string, string> = {
  FirstName: 'phishing.simulations.modal.aiSimulation.editor.firstName',
  LastName: 'phishing.simulations.modal.aiSimulation.editor.lastName',
};

class AiEmailPlaceholderBlot extends Embed {
  static create(value: string) {
    const node = super.create(value) as HTMLElement;
    node.setAttribute(PLACEHOLDER_ATTRIBUTE, value);
    node.textContent = t(
      PLACEHOLDER_LABEL_KEYS[value] ?? PLACEHOLDER_LABEL_KEYS.FirstName,
    );
    return node;
  }

  static value(node: HTMLElement) {
    return node.getAttribute(PLACEHOLDER_ATTRIBUTE);
  }
}

AiEmailPlaceholderBlot.blotName = AI_EMAIL_PLACEHOLDER_FORMAT;
AiEmailPlaceholderBlot.tagName = 'SPAN';
AiEmailPlaceholderBlot.className = AI_EMAIL_PLACEHOLDER_CLASS;

class AiEmailLinkBlot extends Inline {
  static formats(node: HTMLElement) {
    return node.classList.contains(AI_EMAIL_LINK_CLASS) || undefined;
  }
}

AiEmailLinkBlot.blotName = AI_EMAIL_LINK_FORMAT;
AiEmailLinkBlot.tagName = 'A';
AiEmailLinkBlot.className = AI_EMAIL_LINK_CLASS;

class AiEmailSenderBlot extends Inline {
  static formats(node: HTMLElement) {
    return node.classList.contains(AI_EMAIL_SENDER_CLASS) || undefined;
  }
}

AiEmailSenderBlot.blotName = AI_EMAIL_SENDER_FORMAT;
AiEmailSenderBlot.tagName = 'SPAN';
AiEmailSenderBlot.className = AI_EMAIL_SENDER_CLASS;

class AiEmailSoftBreakBlot extends Parchment.Embed {}

AiEmailSoftBreakBlot.blotName = AI_EMAIL_SOFT_BREAK_FORMAT;
AiEmailSoftBreakBlot.tagName = 'BR';
AiEmailSoftBreakBlot.className = AI_EMAIL_SOFT_BREAK_CLASS;

Quill.register(AiEmailPlaceholderBlot);
Quill.register(AiEmailLinkBlot);
Quill.register(AiEmailSenderBlot);
Quill.register(AiEmailSoftBreakBlot);
